<template>
  <v-app class="us-v-app">
    <v-app-bar color="blue-grey" dense dark app>
      <v-btn v-if="barVis" icon @click="goBack">
        <v-icon style="font-size:2rem;">mdi-chevron-left</v-icon>
      </v-btn>
      <v-toolbar-title style="font-size:1rem;">
        全部历史
        <span v-if="camName"> - {{camName}}</span>
      </v-toolbar-title>
    </v-app-bar>
    <v-content style="background: #eee;">
      <v-container style="padding:0;padding-bottom:4rem;">
        <v-flex>
          <div style="padding-top: 1rem;padding-left: 0.5rem;padding-bottom:0.35rem;">
            <span class="us_block_title">查询</span>
          </div>
          <v-card style="margin: 0 0.5rem;">
            <v-col
              cols="12"
            >
              <v-text-field
                v-model="listFilter.car_no"
              >
                <span
                  slot="prepend"
                  style="width: 75px;"
                >
                  车牌号码
                </span>
              </v-text-field>
              <v-select
                v-model="listFilter.peccancy_type"
                :items="peccancyItems"
                item-text="state"
                item-value="abbr"
              >
                <span
                  slot="prepend"
                  style="width: 75px;"
                >
                  违章类型
                </span>
              </v-select>
              <v-text-field
                v-model="startData"
                @click="setDataType('start')"
              >
                <span
                  slot="prepend"
                  style="width: 75px;"
                >
                  开始时间
                </span>
              </v-text-field>
              <v-text-field
                v-model="endData"
                @click="setDataType('end')"
              >
                <span
                  slot="prepend"
                  style="width: 75px;"
                >
                  结束时间
                </span>
              </v-text-field>
              <div style="text-align: center;margin-bottom: 10px;">
                <v-btn
                  style="width: 80%;font-size: 18px;"
                  depressed
                  color="primary"
                  @click="setSearchCondition"
                >
                  查询
                </v-btn>
              </div>
              <v-divider></v-divider>
              <div style="margin-top: 10px;">
                <span style="font-size: 20px;font-weight: bold;">
                  总数：
                  <span>{{listCount}}</span>
                </span>
              </div>
            </v-col>
          </v-card>
        </v-flex>
        <div v-if="loading" style="margin-top:10rem;">
          <LoadingText />
        </div>
        <div v-else>
          <div style="padding-top: 1rem;padding-left: 0.5rem;padding-bottom:0.35rem;">
            <span class="us_block_title">历史记录</span>
          </div>
          <div v-if="list.length > 0" style="color:#fff;padding:0.5rem;">
            <div v-for="(item,index) in list" :key="index">
              <NotifyCard :item="item" flat />
            </div>
          </div>
          <div v-if="list.length === 0" style="text-align:center;margin-top:10rem;color:#9e9e9e;font-size:0.8rem;">
              暂无记录
          </div>
          <div v-else>
            <div style="text-align:center;margin:1.7rem 0 0.5rem;" v-if="hasMore">
              <v-btn color="primary" style="width:10rem;" @click="clickLoadMore">加载更多</v-btn>
            </div>
            <div v-else style="text-align:center;font-size:0.8rem;color:#9e9e9e;margin-top:1.7rem;">
              没有更多数据!
            </div>
          </div>
        </div>
        <ScrollTop />
        <v-dialog
          ref="dialog"
          v-model="modal"
          persistent
          width="290px"
        >
          <v-date-picker
            v-model="dialogData"
            scrollable
            locale="zh-cn"
          >
            <v-spacer></v-spacer>
            <v-btn
              text
              color="primary"
              @click="modal = false"
            >
              取消
            </v-btn>
            <v-btn
              text
              color="primary"
              @click="setData(dialogData)"
            >
              确定
            </v-btn>
          </v-date-picker>
        </v-dialog>
      </v-container>
    </v-content>
  </v-app>

</template>

<script>
import LoadingText from '../../components/LoadingText'
import NotifyCard from './components/NotifyCard.vue'
import ScrollTop from './components/ScrollTop.vue'
export default {
  components: { LoadingText, NotifyCard, ScrollTop },
  props: {
  },
  data() {
    return {
      loading: true,
      list: [],
      pageIndex: 1,
      pageCount: 10,
      hasMore: true,
      listFilter: {
        create_time: [],
        peccancy_type: '',
        run_type: '',
        car_no: '',
        seq_code: '',
        dept: '',
        us_text: '',
        car_type: '',
        car_no_color: '',
        car_color: ''
      },
      camName: '',
      barVis: false,
      modal: false,
      dataType: 'start',
      dialogData: '',
      startData: '',
      endData: '',
      peccancyItems: [
        { state: '全部', abbr: '' },
        { state: '正常', abbr: '正常' },
        { state: '超速', abbr: '超速' }
      ],
      listCount: 0
    }
  },
  computed: {
  },
  mounted() {
  },
  created() {
  },
  activated() {
    var that = this
    that.$store.commit('SET_FNAVVAL', 2)
    that.init()
    if (that.$route.query.seq_code) {
      that.listFilter.seq_code = that.$route.query.seq_code
    }
    if (that.$route.query.cam_name) {
      that.camName = that.$route.query.cam_name
    }

    var type = that.$route.query.type
    if (type) {
      if (type === 1) {
        that.listFilter.peccancy_type = '正常'
        that.camName = '正常'
      } else if (type === 2) {
        that.listFilter.peccancy_type = '超速'
        that.camName = '超速'
      }
    }
    that.getList()
  },
  methods: {
    init() {
      var that = this
      that.barVis = false
      that.listFilter = {
        create_time: [],
        peccancy_type: '',
        run_type: '',
        car_no: '',
        seq_code: '',
        dept: '',
        us_text: '',
        car_type: '',
        car_no_color: '',
        car_color: ''
      }
      that.camName = ''

      var starttime = that.$moment().format('YYYY-MM-DD')
      var endtime = starttime

      that.listFilter.create_time = [starttime, endtime]
      that.startData = starttime
      that.endData = endtime

      that.list = []
      that.pageIndex = 1
      that.pageCount = 10
    },
    goBack() {
      this.$router.goBack()
    },
    async getList() {
      var that = this
      if (that.pageIndex === 1) {
        that.list = []
        that.loading = true
      }
      // var res = await that.$api.bz.queryCamImageList({ page_index: that.pageIndex, page_count: that.pageCount })
      var res = await that.$api.bz.queryCamImageList({ page_index: that.pageIndex, page_count: that.pageCount, str_filter: JSON.stringify(that.listFilter) })
      if (!res.success) {
        console.log('获取列表失败', res);
        that.loading = false
        return;
      }
      var sm = res.data

      var data = sm.list
      that.listCount = sm.count

      if (data.length == 0) {
        that.loading = false
        that.hasMore = false;
        return;
      }
      that.hasMore = data.length >= that.pageCount;
      for (let index = 0; index < data.length; index++) {
        const item = data[index];
        that.list.push(item);
      }
      that.loading = false
    },
    clickLoadMore() {
      var that = this
      that.pageIndex++;
      that.getList();
    },
    setDataType(v) {
      var that = this
      that.dataType = v
      if (v === 'start') {
        that.dialogData = that.startData
      } else {
        that.dialogData = that.endData
      }
      that.modal = true
    },
    setData(v) {
      var that = this
      if (that.dataType === 'start') {
        that.startData = v
      } else {
        that.endData = v
      }
      that.modal = false
    },
    setSearchCondition() {
      var that = this
      that.listFilter.create_time = [that.startData, that.endData]
      that.pageIndex = 1
      that.getList()
    },
    goDeviceNotifyStat() {
      this.$router.goPage('/DeviceNotifyStat')
    }
  }
}
</script>

<style scoped>
.us-v-badge >>> .v-badge__badge{
  height: 5px !important;
  width: 5px !important;
}

.us-list-item >>> .v-list-item__icon{
  min-width: 0.9rem;
}
.us-create-btn{
  position:fixed;
  bottom: 4rem;
  right: 1.5rem;
}
.us_block_title{
  font-weight:bold;
  font-size:1.05rem;
  color: rgba(33,33,33,0.9);
}
</style>

